module.exports = __webpack_public_path__ + "img/grillo-emiliano-golf.877c29e3.jpg";